import { MergeWasteStreamsInput } from "generated-graphql/graphql";

export interface WasteStreamMergeFormData {
  comment?: string;
  internalNote?: string;
  wasteStreamName: string;
  wasteStreamIds: string[];
  stateRegistrationSourceWasteStreamId?: string;
}

export function buildMergeInput(
  data: WasteStreamMergeFormData,
  showRegistrationPicker: boolean
): MergeWasteStreamsInput {
  return {
    wasteStreamIds: data.wasteStreamIds,
    name: data.wasteStreamName.trim(),
    comment: data.comment?.trim(),
    internalNote: data.internalNote?.trim() || undefined,
    stateRegistrationSourceWasteStreamId: showRegistrationPicker
      ? data.stateRegistrationSourceWasteStreamId
      : undefined,
  };
}
